import { handleActions } from 'redux-actions';
import { createSelector } from '@reduxjs/toolkit';
import {
  DOWNLOAD_SESSION,
  LOAD_SESSION_LIST,
} from './actions';
import { SESSION_MODULE } from '../../configs/moduleNames';
import { createLoadListReducer, createOperationStateReducer } from '../../utils/getCrudConfig';

const initialState = {
  loadingSessionList: false,
  sessionList: [],
  sessionListMeta: {},
  downloadingSession: false,
};

const reducer = handleActions({
  ...createLoadListReducer(SESSION_MODULE + LOAD_SESSION_LIST, 'sessionList', 'loadingSessionList'),
  ...createOperationStateReducer(SESSION_MODULE + DOWNLOAD_SESSION, 'downloadingSession'),
}, initialState);

export default reducer;

export const getSessionData = createSelector(
  [state => state[SESSION_MODULE]],
  state => {
    const {
      loadingSessionList,
      sessionList,
      sessionListMeta,
      downloadingSession,
    } = state;
    return {
      loadingSessionList,
      sessionList,
      sessionListMeta,
      downloadingSession,
    };
  },
);
